import React, { useEffect, useState } from "react";
import UnderlineAnimation, {
  startUnderlineAnimation,
  stopUnderlineAnimation,
} from "../../Animations/UnderlineAnimation";
import ExternalLinkIcon from "../../SVGs/ExternalLink";
import { useMenuContentAnimation } from "../utils/useMenuContentAnimationHook";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import { useAnimation } from "framer-motion";
import { NavLinkClickHandler } from "src/assets/Types/Redesign/PrimaryNavMenuType.type";

type NavLink = {
  copy: string;
  page: string;
  url?: string;
  description?: string;
  externalLink?: boolean;
};

type CategoryType = {
  categoryTitle: string;
  navLinks: NavLink[];
};
type MenuItemListProps = {
  category: CategoryType;
  isOpen?: boolean;
  title: string;
};

const MenuItemList: React.FC<MenuItemListProps & NavLinkClickHandler> = ({
  category,
  isOpen,
  onClickHandler,
  title,
}) => {
  const [isOpened, setIsOpened] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setIsOpened(true);
      }, 500);
    }
    return () => {
      setIsOpened(false);
    };
  }, [isOpen]);
  const animateClassName = "menuItemListAnimation";
  const { ref, controls } = useMenuContentAnimation(isOpen);
  const addAnimateClassIndex =
    category?.navLinks?.length < 3 ? 0 : category?.navLinks?.length - 3;

  return (
    <div className="w-1/4 flex-col items-start self-stretch">
      <div className="flex flex-col gap-6">
        <p className="body--text-eyebrow min-h-[23px]">
          {category.categoryTitle}
        </p>
        <ul className="flex flex-col gap-6 list-none pl-0" ref={ref}>
          {category?.navLinks?.map((navLink, index) => {
            const controls = useAnimation();

            return (
              <NavigationMenu.Link
                key={index}
                className="w-fit no-underline"
                href={navLink.page || navLink.url}
                target={navLink.externalLink ? "_blank" : "_self"}
                onMouseEnter={() => controls.start(startUnderlineAnimation)}
                onMouseLeave={() => controls.start(stopUnderlineAnimation)}
                onClick={e => onClickHandler(e, { category: title })}
              >
                <li
                  key={index}
                  className={
                    index > addAnimateClassIndex ? animateClassName : ""
                  }
                >
                  <div className="w-fit body--text-large">
                    <UnderlineAnimation extraControls={controls}>
                      <div className="flex gap-2">
                        {navLink.copy}
                        {navLink.externalLink && (
                          <div className="flex items-center justify-center">
                            <ExternalLinkIcon />
                          </div>
                        )}
                      </div>
                    </UnderlineAnimation>
                  </div>
                  {navLink.description && (
                    <div className="body--text-small !text-forest-600">
                      {" "}
                      {navLink.description}
                    </div>
                  )}
                </li>
              </NavigationMenu.Link>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default MenuItemList;
